import { SaveLocationsDocument } from '~/client/graph/operations/generated/Locations.generated'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import Gate from '~/client/src/shared/models/LocationObjects/Gate'
import ILocationAttributeDto from '~/client/src/shared/types/ILocationAttributeDto'

import LocationAttributesStoreBase from './LocationAttributesBase.store'

export default class GatesStore extends LocationAttributesStoreBase<Gate> {
  protected saveMutation = SaveLocationsDocument
  protected graphName = 'locations'
  protected defaultIconName = MapViewLocationIcon.Gate

  public get byId() {
    const { gates } = this.eventsStore.appState
    return gates
  }

  protected fromDto(dto: ILocationAttributeDto): Gate {
    return Gate.fromDto(dto)
  }
}
